import type { ComponentSchema } from '../../../schema-types'
import { SECTION_STYLE_FIELDS } from '../../lightings/lightings-1/_builder-constants'

const SLOT_OPTIONS = [
  { label: 'Processor', value: 'cpu' },
  { label: 'Motherboard', value: 'motherboard' },
  { label: 'Memory (RAM)', value: 'ram' },
  { label: 'Storage', value: 'storage' },
  { label: 'Graphics card', value: 'gpu' },
  { label: 'Power supply', value: 'psu' },
  { label: 'Casing', value: 'case' },
  { label: 'CPU cooler', value: 'cooler' },
  { label: 'Monitor', value: 'monitor' },
]

/** PC Builder: one row per part, a product picker per part with compatibility checks, total, add all to cart. */
export const schema: ComponentSchema = {
  type: 'pc-builder',
  label: 'PC Builder',
  description: 'Shoppers pick a part for each slot, see whether the parts fit together, then add the whole build to the cart.',
  supportedPages: ['pc-builder'],
  variants: [{ id: 'v1', label: 'Part list' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'PC Builder' },
    { key: 'subtitle', label: 'Subtitle', type: 'text', default: 'Pick your parts. We check that they fit together.' },
    {
      key: 'slots',
      label: 'Parts',
      type: 'array',
      help: 'Empty category = the category whose name matches the part (Processor, Motherboard…).',
      itemSchema: [
        { key: 'slot', label: 'Part', type: 'select', options: SLOT_OPTIONS, default: 'cpu' },
        { key: 'label', label: 'Name', type: 'string' },
        { key: 'categoryId', label: 'Category', type: 'category-select' },
        { key: 'required', label: 'Required', type: 'boolean', default: false },
      ],
      default: SLOT_OPTIONS.map(o => ({ slot: o.value, label: o.label, categoryId: '', required: ['cpu', 'motherboard', 'ram', 'storage', 'psu', 'case'].includes(o.value) })),
    },
    { key: 'headroomPercent', label: 'Power supply spare capacity (%)', type: 'number', default: 30 },
    { key: 'showOnlyCompatible', label: 'Hide parts that do not fit', type: 'boolean', default: false },
    {
      key: 'labels',
      label: 'Texts',
      type: 'object',
      fields: [
        { key: 'addAllLabel', label: 'Add all button', type: 'string', default: 'Add all to cart' },
        { key: 'totalLabel', label: 'Total', type: 'string', default: 'Total' },
        { key: 'printLabel', label: 'Print button', type: 'string', default: 'Print' },
        { key: 'shareLabel', label: 'Share button', type: 'string', default: 'Share' },
        { key: 'incompatibleLabel', label: 'Not compatible', type: 'string', default: 'Not compatible' },
        { key: 'emptySlotLabel', label: 'Empty part', type: 'string', default: 'Not selected' },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
